module.exports = __webpack_public_path__ + "static/media/Risk-BasedSolutions.d0719327.psd";